import Image from 'next/image';

import ErrorIcon from '@/assets/icons/auth-toast-error-icon.svg';
import SuccessIcon from '@/assets/icons/auth-toast-success-icon.svg';

import '@/styles/globals.v2.css';

interface AuthToastProps {
  type: 'error' | 'success' | 'info';
  message: string;
  closeToast?: () => void;
}

const AuthToast: React.FC<AuthToastProps> = ({ type, message }) => {
  return (
    <div className="v2-flex v2-flex-col v2-gap-2">
      {type === 'success' ? (
        <Image src={SuccessIcon} width={38} height={38} alt="Success Icon" />
      ) : (
        <Image src={ErrorIcon} width={38} height={38} alt="Error Icon" />
      )}

      <p className="v2-font-sweet-sans-pro-semi-bold v2-font-semibold v2-text-sm v2-text-[#344054] v2-ml-[9px] v2-mr-[9px] v2-mb-[9px]">
        {message}
      </p>
    </div>
  );
};

export default AuthToast;
